import React from 'react';
import { compose, lifecycle } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Toolbar from '@material-ui/core/Toolbar';

const styles = {
  grow: {
    flexGrow: 1,
    textAlign: 'center',
    fontSize: 10
  }
};

const enhance = compose(
  // add botchat karakuri into web manager
  lifecycle({
    async componentDidMount() {
      // let addPopupJs = true;
      // const url = 'https://gochimeshi.karakuri.ai/api/chats/popup.js';
      // const scripts = document.getElementsByTagName('script');
      // // eslint-disable-next-line no-plusplus
      // for (let i = scripts.length; i--; ) {
      //   if (scripts[i].src === url) {
      //     addPopupJs = false;
      //   }
      // }
      // const script = document.createElement('script');
      // script.src = url;
      // script.async = true;
      // if (addPopupJs) {
      //   document.body.appendChild(script);
      // }
    }
  })
);

const Header = enhance(({ classes }) => {
  return (
    <Toolbar>
      <Typography
        variant="body2"
        color="textSecondary"
        align="center"
        className={classes.grow}
      >
        {'© 2019-'}
        {new Date().getFullYear()}
        {' Gigi Inc.'}
        <br />
        (Ver 1.18.0)
      </Typography>
    </Toolbar>
  );
});

export default withRouter(withStyles(styles)(Header));
